/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useEditPhotoStyles = makeStyles({
  root: {
    width: '100%',
    minWidth: '325px',
  },
  cropContainer: {
    height: '400px',
    width: '100%',
    position: 'relative',
    // backgroundColor: "#ccc",
  },
  controls: {
    margin: '15px 0',
  },
  sliderContainer: {},
});
